(() => {
  if (customElements.get('sf-about')) return;
  customElements.define('sf-about', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (window.Shopify && window.Shopify.designMode) this.setAttribute('data-sa-static', '');
      this.mobile = matchMedia('(max-width: 749px), (hover: none)');
      // Phones (< 750px): the category list is an accordion, each row opens its own photo.
      this.accordion = matchMedia('(max-width: 749px)');
      this.word = this.querySelector('[data-sa-word]');
      this.rows = [...this.querySelectorAll('[data-sa-segment]')];
      this.photos = [...this.querySelectorAll('[data-sa-photo]')];
      this.words = this.rows.map(row => row.dataset.saTitle).filter(Boolean);
      this.index = 0; this.wordIndex = 0; this.editorSelected = false; this.focused = false;
      this.interval = Math.max(3000, Number(this.dataset.interval) || 4000);
      this.rows.forEach((row, index) => {
        row.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'touch' && !this.accordion.matches) this.show(index);
        }, options);
        row.addEventListener('focusin', () => {
          this.focused = true;
          if (!this.accordion.matches) this.show(index);
          this.schedule();
        }, options);
        row.addEventListener('focusout', () => { this.focused = false; this.schedule(); }, options);
        row.addEventListener('click', event => {
          if (this.accordion.matches) {
            if (event.target.closest('a')) return; // title link still navigates
            this.toggle(index);
          } else {
            this.show(index);
          }
        }, options);
        row.addEventListener('keydown', event => {
          if (!this.accordion.matches || event.target !== row) return;
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); this.toggle(index); }
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.rows.findIndex(row => row.dataset.saSegment === event.detail?.blockId);
        if (index >= 0) { this.editorSelected = true; this.show(index); this.schedule(); }
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.mobile.addEventListener('change', () => this.schedule(), options);
      this.accordion.addEventListener('change', () => { this.show(Math.max(this.index, 0)); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.show(0); this.schedule();
    }
    show(index) {
      if (!this.rows.length) return;
      this.index = index < 0 ? -1 : index % this.rows.length;
      const id = this.index >= 0 ? this.rows[this.index].dataset.saSegment : null;
      this.rows.forEach((row, i) => {
        row.classList.toggle('is-active', i === this.index);
        if (this.accordion.matches) row.setAttribute('aria-expanded', i === this.index ? 'true' : 'false');
        else row.removeAttribute('aria-expanded');
      });
      if (id) this.photos.forEach(photo => { photo.hidden = photo.dataset.saPhoto !== id; });
    }
    toggle(index) {
      const opening = this.index !== index;
      this.show(opening ? index : -1);
      if (!opening) return;
      const row = this.rows[index];
      // keep the opened row in view after the previous one collapses above it
      setTimeout(() => {
        const top = row.getBoundingClientRect().top;
        if (top < 70 || top > window.innerHeight * 0.6) {
          window.scrollBy({ top: top - 80, behavior: this.motion.matches ? 'auto' : 'smooth' });
        }
      }, this.motion.matches ? 0 : 460);
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.motion.matches || document.hidden || this.editorSelected || this.focused) return;
      const rotateRows = this.mobile.matches && !this.accordion.matches && this.rows.length > 1;
      if (this.words.length < 2 && !rotateRows) return;
      this.timer = setTimeout(() => {
        if (this.words.length && this.word) {
          this.wordIndex = (this.wordIndex + 1) % this.words.length;
          this.word.textContent = this.words[this.wordIndex];
        }
        if (rotateRows) this.show(this.index + 1);
        this.schedule();
      }, this.interval);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.controller = null; }
  });
})();
